import React from 'react';
import styled from 'styled-components';
import { Text } from '../Text';

interface CashierActionButtonProps {
    icon: React.ReactNode;
    title: string;
    onClick?: () => void;
    className?: string;
    active?: boolean;
    color?: string;
}

const StyledCashierActionButton = styled.div<{ color?: string }>`
    display: flex;
    width: 110px;
    padding: 4px;
    border-radius: 5px;
    gap: 10px;
    border: 1px solid ${({ color }) => color || '#FFF'};
    box-sizing: border-box;
`;

const StyledIcon = styled.div<{ color?: string }>`
    display: flex;
    width: 102px;
    height: 102px;
    padding: 4px;
    border: ${({ color }) => color ? '1px solid #FFF' : '1px solid #232F3E'};
    border-radius: 5px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    box-sizing: border-box;

    &.fzt-active-button {
        background: ${({ color }) => color || '#FFF'};
    }
`;

const ProductCard: React.FC<CashierActionButtonProps> = ({ icon, title, onClick, className, color, active }) => {
    return (
        <StyledCashierActionButton className={className} onClick={onClick} color={color}>
            <StyledIcon className={active ? 'fzt-active-button' : ''} color={color}>
                {icon}
                {active ? 
                    <Text content_3 semibold color='neutral.text.1'>{title}</Text> 
                    : 
                    <Text content_3 semibold color='neutral.text.5'>{title}</Text>
                }
            </StyledIcon>
        </StyledCashierActionButton>
    );
};
    
export default ProductCard;